import { Calendar, Col, Popover } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const MiniDateCal = styled(Calendar)`
  .ant-picker-content {
    border-collapse: collapse !important;
    thead {
      padding: 0.5rem;
      text-align: center;
      th {
        height: auto;
        padding: 0.75rem !important;
        line-height: 18px;
        border: 1px solid lightgray;
        background-color: #fafafb;
      }
    }
  }
  .ant-picker-calendar-mini .ant-picker-content th {
    padding: 10 !important;
  }
  td {
    border: 0px !important;
  }
  .ant-picker-cell {
    border: 1px solid lightgray !important;
  }
  .ant-picker-cell-in-view {
    color: #4d566e !important;
  }
  .ant-picker-calendar-date-value {
    text-align: left !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    height: 35px !important;
    width: 35px !important;
    border-radius: 50% !important;
    justify-content: center !important;
    padding-top: 5px !important;
    z-index: 1;
    background-color: ${COLORS.PURPLE_T_98};
  }
  .ant-picker-cell-in-view.ant-picker-cell-today {
    color: ${COLORS.PRIMARY_PURPLE};
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 0px !important;
  }
`
export const LeftCol = styled(Col)`
  padding-left: 20px;
`
export const CenterCol = styled(Col)`
  text-align: center;
`
export const Wrapper = styled(Flex)`
  width: 80vw;
`
export const FilterSection = styled.div`
  flex-grow: 1;
  min-width: 15%;
  position: relative;
  top: 2.8rem;
  padding: 1rem 0.6rem;
  border-top: 1px solid ${COLORS.GREY_T_85};
`
export const CalendarSection = styled.div`
  max-width: 82%;
`
export const FilterLabel = styled(Label)`
  margin-left: 1rem;
  font-size: 14px;
`
export const StyledUl = styled.ul`
  width: 100%;
  text-overflow: ellipsis;
  list-style-type: none;
  padding: 0;
  position: absolute;
  transform: translateX(-8px);
`
export const ListTag = styled.li`
  width: 100%;
  border: 3px solid ${COLORS.BORDER};
  border-radius: 12px;
  list-style-position: inside;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fff;
  position: relative;
  z-index: 999;
  padding: 0 4px;
  //min-width: 5rem;
`
export const LightText = styled.div`
  color: ${COLORS.BORDER};
  font-size: 10px;
  font-weight: 500;
  text-transform: capitalize !important;
`
export const HoverText = styled.div`
  width: 100%;
  height: 100%;
`
export const CustomPopover = styled(Popover)`
  .ant-popover {
    background-color: white;
  }
`
export const StyledUlForCalendar = styled.ul`
  list-style-type: none;
  padding: 0;
  position: absolute;
  transform: translateX(-8px);
  margin: -15px;
`
export const TitleOutline = styled.div`
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  color: ${props => props.textColor} !important;
  background-color: ${props => props.backgroundColor} !important;
  border-radius: 20px;
  max-width: fit-content;
  padding: 0px 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;

`
export const TitleOutlineAll = styled.div`
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  color: ${props => props.textColor} !important;
  background-color: transparent !important;
  border: none !important;
  max-width: fit-content;
  padding: 0px 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;


  &::before {
    content: '•';
    color: ${props => props.textColor}!important;
    font-size: 16px;
    margin-right: 4px;
  }
`
export const SmallText = styled.div`
  font-size: 8px;
  font-weight: 400;
  line-height: 9px;
  max-width: fit-content;
  color: black;
  padding: 0px 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 5px;
`

export const BigText = styled.div`
  font-size: 8px;
  font-weight: 700;
  line-height: 9px;
  padding: 0px 5px;
  color: black;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SectionWrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  // gap: 10px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
`
export const DynamicText = styled.div`
  color: #000000;
  font-size: 14px;
  font-weight: 400;
`
export const StatusButton = styled(Button.Primary)`
  font-size: 14px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 6px 5px 6px 5px;
  border-radius: 10px;
  font-weight: 600;
  margin-left: auto;
  // width: 106px;
  height: 35px;
  text-align: center;
  width: 110px;
`
